<template>
  <div class="individuals-gallery">
    <div class="gallery-item" v-for="(g, i) in gallery" :id="i" :key="`gallery-item-${i}`">
      <img v-if="g.type === 'image'" :src="g.url" :alt="`Gallery item ${i}`" @click="openModal(g)">
      <video v-else-if="g.type === 'video'" autoplay muted loop @click="openModal(g)">
        <source :src="g.url" type="video/mp4">Your browser does not support the video tag.
      </video>
    </div>
    <transition name="fade">
      <MediaModal v-if="selected" :media="selected"/>
    </transition>
  </div>
</template>

<script>
export default {
  components: {
    MediaModal: () => import("../../../shared/MediaModal.vue")
  },
  props: ["gallery"],
  data() {
    return {
      selected: null
    };
  },
  methods: {
    openModal(media) {
      this.selected = media;
    },
    closeModal() {
      this.selected = null;
    }
  },
  mounted() {
    this.$on("close-media-modal", this.closeModal);
  },
  destroyed() {
    this.$off("close-media-modal");
  }
};
</script>

<style lang="scss" scoped>
.individuals-gallery {
  display: flex;
  margin-bottom: 30px;
  overflow: auto;
  width: 100%;
  .gallery-item {
    align-items: center;
    display: flex;
    cursor: pointer;
    margin: 0 5px;
    overflow: hidden;
    width: 100%;
    @include transition(all 0.3s);
    img,
    video {
      background-color: black;
      display: block;
      height: auto;
      width: 100%;
    }
    video {
      object-fit: cover;
      -o-object-fit: cover;
      height: 100%;
    }
  }
  .gallery-item:hover {
    opacity: 0.8;
  }
}
@media screen and (max-width: 1000px) {
  .individuals-gallery {
    .gallery-item {
      min-width: 40vw;
    }
  }
}
@media screen and (max-width: 600px) {
  .individuals-gallery {
    .gallery-item {
      min-width: 65vw;
    }
  }
}
</style>

